<template>
  <div id="showtable">
    <template v-if="!selectedMatchAllBet">
      <!-- Today RB -->
      <template v-if="(selectedMarket=='1' && sortedRBEventList && Object.keys(sortedRBEventList).length > 0)">
        <todayHeader :marketType="market.inPlayMarket.key" @updateMethod="showMarketMatches"></todayHeader>
        <template v-if="showRBhideAll">
          <template v-for="(eventObj, eventObjKey) in sortedRBEventList">
            <!-- League Capt -->
            <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important; top: 73.5px;">
              <div class="list-card-inner" :key="eventObjKey">
                <div class="c-match-league match-tpl0-bg"
                  :class="checkClass(showRBLgeEve, eventObjKey)" @click="showLeg(eventObjKey, true)">
                  <div class="tr-match-head">
                    <div class="leagues-wrap"  :style="{ width: (simpleSport==null)? widthColumn[2] + 'px':'700px' }">
                      <i size="14px" class="icon-arrow q-icon c-icon"></i>
                      <div class="league-icon-wrap">
                        <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                      </div> 
                      <div class="ellipsis-wrap">
                        <div class="absolute-full">
                          <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                          <span class="league-match-count">{{ eventObj.length }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="play-name vrow col">
                      <template v-if="simpleSport==null">
                        <div class="col ellipsis bet-col0">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'] }}
                        </div>
                        <div class="col ellipsis bet-col1">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'] }}
                        </div>
                        <div class="col ellipsis bet-col2">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'] }}
                        </div>
                        <template v-if="selectedLang == 1">
                          <div class="col ellipsis bet-col3">
                            <div class="double-row">
                              <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2'] }}</div>
                              <div class="highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                              </div>
                            </div>
                          </div>
                          <div class="col ellipsis bet-col4">
                            <div class="double-row">
                              <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP'] }}</div>
                              <div class="highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                              </div>
                            </div>
                          </div>
                          <div class="col ellipsis bet-col5">
                            <div class="double-row">
                              <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U'] }}</div>
                              <div class="highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                              </div>
                            </div>
                          </div>

                          <template v-if="isUnfold">
                            <div class="col ellipsis bet-col6" v-if="widthColumn[3]==0">
                              <div class="double-row">
                                <div class="">Half With </div>
                                <div class=""> Most Goals</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col7">
                              <div class="double-row">
                                <div class="">{{ sportAllBetLang['ALL_BET.LBL_HOME'] }}</div>
                                <div class="">{{ sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL'] }}</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col8">
                              <div class="double-row">
                                <div class="">{{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}</div>
                                <div class="">{{ sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL'] }}</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col9"> 
                              <div class="double-row">
                                <div class="">Both Teams</div>
                                <div class=""> To Scores</div>
                              </div>
                            </div> 
                            <div class="col ellipsis bet-col10"  v-if="widthColumn[3]<2">
                              <div class="double-row">
                                <div class="">To Win</div>
                                <div class=""> From Behind</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col11"> {{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }} </div> 
                            <div class="col ellipsis bet-col12"> {{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }} </div>
                          </template>

                        </template>
                        <template v-else>
                          <div class="col ellipsis bet-col3 highlight-t">
                            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'] }}
                          </div>
                          <div class="col ellipsis bet-col3 highlight-t">
                            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'] }}
                          </div>
                          <div class="col ellipsis bet-col3 highlight-t">
                            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'] }}
                          </div>
                          <template v-if="isUnfold">
                            <div class="col ellipsis bet-col6" v-if="widthColumn[3]==0">{{ sportAllBetLang['ALL_BET.SUBHEADER_HMG'] }}</div>
                            <div class="col ellipsis bet-col7"> {{ sportAllBetLang['ALL_BET.HTG'] }} </div>
                            <div class="col ellipsis bet-col8"> {{ sportAllBetLang['ALL_BET.ATG'] }} </div>
                            <div class="col ellipsis bet-col9">  {{ sportAllBetLang['ALL_BET.SUBHEADER_BTTS'] }}</div> 
                            <div class="col ellipsis bet-col10"  v-if="widthColumn[3]<2">  {{ sportAllBetLang['ALL_BET.SUBHEADER_TWFB'] }}  </div>
                            <div class="col ellipsis bet-col11"> {{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }} </div> 
                            <div class="col ellipsis bet-col12"> {{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }} </div>
                          </template>
                        </template>
                      </template>
                    </div>
                    <div class="yb-flex-center" style="width: 39px !important;">
                      <div class="icon-wrap m-star-wrap-league"
                        :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }" @click="favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)">
                        <i class=" icon-star q-icon c-icon" :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- League Events -->
            <template v-if="showRBLgeEve[eventObjKey]">
            <template v-if="!showRBLgeEve[eventObjKey].hide">
              <template v-for="(event, eventKey) in eventObj" v-if="eventKey!='hide'">
                <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw', true)" v-if="simpleSport==null">
                  <div class="list-card-inner">
                    <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec', true)">
                      <div class="c-match-item match-tpl0-bg more-handicap csid-1">
                        <div class="process-col yb-flex-center">
                          <sportTime :event="event"></sportTime>
                        </div>

                        <div class="match-handicap-item-wrap">
                          <template v-for="(subMatch, subMatchKey) in (event.sub + 1)" v-if="showSubMatch(subMatch, event, subMatchKey, true)">
                            <div class="match-handicap-item">
                              <sportTeam :event="event" :issc="true" classes="none" :subMatchKey="subMatchKey" :plyType="ftPlyType" :isRB="true" :widthL="widthColumn[0]"></sportTeam>
                              <div class="c-match-handicap" :id="'cmatch'+event.eveid">
                                <div class="vrow no-wrap">
                                  <!-- FT R1X2 -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+ronex2BetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[ftPlyType] && event.od[ftPlyType][ronex2BetType] && event.od[ftPlyType][ronex2BetType]['oddsh']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">1</template>
                                                <template v-else>{{ sportAllBetLang['ALL_BET.LBL_HOMEWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="ronex2BetType" />
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[ftPlyType] && event.od[ftPlyType][ronex2BetType] && event.od[ftPlyType][ronex2BetType]['oddsa']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">2</template>
                                                <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway"
                                          :plyType="ftPlyType" :betType="ronex2BetType" />
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[ftPlyType] && event.od[ftPlyType][ronex2BetType] && event.od[ftPlyType][ronex2BetType]['oddsd']">
                                                  <template v-if="selectedLang=='4' || selectedLang=='11'">X</template>
                                                  <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw"
                                            :plyType="ftPlyType" :betType="ronex2BetType" />
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                  <!-- FT RHDP -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+rhdpBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'a'" :plyType="ftPlyType"
                                              :betType="rhdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="rhdpBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'b'" :plyType="ftPlyType" :betType="rhdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="rhdpBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>
                                  <!-- FT ROU -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+rouBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template
                                              v-if="event.od[ftPlyType] && event.od[ftPlyType][rouBetType] && event.od[ftPlyType][rouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="ftPlyType" :betType="rouBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="rouBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template
                                              v-if="event.od[ftPlyType] && event.od[ftPlyType][rouBetType] && event.od[ftPlyType][rouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="ftPlyType" :betType="rouBetType"
                                              :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="rouBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>
                                  <!-- 1H R1X2 -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+ronex2BetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ronex2BetType] && event.od[firstHtPlyType][ronex2BetType]['oddsh']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">1</template>
                                                <template v-else>{{ sportAllBetLang['ALL_BET.LBL_HOMEWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome"
                                          :plyType="firstHtPlyType" :betType="ronex2BetType" />
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ronex2BetType] && event.od[firstHtPlyType][ronex2BetType]['oddsa']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">2</template>
                                                <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway"
                                          :plyType="firstHtPlyType" :betType="ronex2BetType" />
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ronex2BetType] && event.od[firstHtPlyType][ronex2BetType]['oddsd']">
                                                  <template v-if="selectedLang=='4' || selectedLang=='11'">X</template>
                                                  <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw"
                                            :plyType="firstHtPlyType" :betType="ronex2BetType" />
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                  <!-- 1H RHDP -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+rhdpBetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'a'" :plyType="firstHtPlyType"
                                              :betType="rhdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="rhdpBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'b'" :plyType="firstHtPlyType"
                                              :betType="rhdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="rhdpBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>
                                  <!-- 1H ROU -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+rouBetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <!-- <template v-if="subMatchKey == 0"> -->
                                              <template
                                                v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][rouBetType] && event.od[firstHtPlyType][rouBetType][getSMKey(subMatchKey)]">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                            <!-- </template> -->
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="firstHtPlyType" :betType="rouBetType"
                                              :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="rouBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template
                                              v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][rouBetType] && event.od[firstHtPlyType][rouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="firstHtPlyType" :betType="rouBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="rouBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>

                                  <!-- Unfold SC All -->
                                  <template v-if="isUnfold">
                                    <!-- HMG1x2 -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+rhmg1x2BetType+ftPlyType+subMatchKeyCap[subMatchKey]" v-if="widthColumn[3]==0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[ftPlyType] && event.od[ftPlyType][rhmg1x2BetType] && event.od[ftPlyType][rhmg1x2BetType]['oddsh']">
                                                  {{ lang.sportAllBet['ALL_BET.LBL_1HT'] }}
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="rhmg1x2BetType" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[ftPlyType] && event.od[ftPlyType][rhmg1x2BetType] && event.od[ftPlyType][rhmg1x2BetType]['oddsa']">
                                                  {{ lang.sportAllBet['ALL_BET.LBL_2HT'] }}
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway"
                                            :plyType="ftPlyType" :betType="rhmg1x2BetType" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                              <div class="handicap-value-text">
                                                <template v-if="subMatchKey == 0">
                                                  <template
                                                    v-if="event.od[ftPlyType] && event.od[ftPlyType][rhmg1x2BetType] && event.od[ftPlyType][rhmg1x2BetType]['oddsd']">
                                                    {{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}
                                                  </template>
                                                </template>
                                              </div>
                                            </div>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw"
                                              :plyType="ftPlyType" :betType="rhmg1x2BetType" />
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                    <!-- RHTG -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+rhtgBetType+ftPlyType+subMatchKeyCap[subMatchKey]" >
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][rhtgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey == 0" :event="event" :plyType="ftPlyType" :betType="rhtgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="rhtgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][rhtgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="rhtgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="rhtgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- RATG -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+ratgBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][ratgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="ratgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="ratgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][ratgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="ratgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="ratgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- RBTTS -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+rbttsBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][rbttsBetType] && event.od[ftPlyType][rbttsBetType]['oddsh']">
                                                  {{ sportAllBetLang['ALL_BET.LBL_YES'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="rbttsBetType" ref="team1" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0 && event.od[ftPlyType] && event.od[ftPlyType][rbttsBetType] && event.od[ftPlyType][rbttsBetType]['oddsa']">
                                                {{ sportAllBetLang['ALL_BET.LBL_NO'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="rbttsBetType" ref="team2" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- R To Win From Behind -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+rtwfbBetType+ftPlyType+subMatchKeyCap[subMatchKey]"  v-if="widthColumn[3]<2">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][rtwfbBetType] && event.od[ftPlyType][rtwfbBetType]['oddsh']">
                                                {{ sportAllBetLang['ALL_BET.LBL_HOME'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="rtwfbBetType" ref="team1" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][rtwfbBetType] && event.od[ftPlyType][rtwfbBetType]['oddsa']">
                                                {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="rtwfbBetType" ref="team2" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- R O/E -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+roeBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][roeBetType]">
                                                {{ sportAllBetLang['ALL_BET.LBL_ODD'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="roeBetType" :match="subMatchKey" ref="teamOdd" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][roeBetType]">
                                                {{ sportAllBetLang['ALL_BET.LBL_EVEN'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="roeBetType" :match="subMatchKey" ref="teamEven" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- R Clean Sheet -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+rcshBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey==0  && event.od[ftPlyType] && event.od[ftPlyType][rcshBetType] && event.od[ftPlyType][rcshBetType]['oddsh']">
                                                {{ sportAllBetLang['ALL_BET.LBL_HOME'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="rcshBetType" ref="team1" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][rcshBetType] && event.od[ftPlyType][rcshBetType]['oddsh']">
                                                {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="rcshBetType" ref="team2" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                  </template>
                                </div>
                              </div>
                              <div class="media-col" v-if="subMatchKey==0">
                                <div class="media-col-wrap">
                                  <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                    <div class="v-icon switch-icon" @click="enterAllBet(event,1, true)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                                  </div>
                                  <div class="yb-flex-center"></div>
                                  <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                                    <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2, true)" :class="{ active: livetvEveid== event.eveid}" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <moreBetComponent v-if="chkMoreBetExist(event, true)" :event="event" :widthColumn="widthColumn" :isUnfold="isUnfold"></moreBetComponent>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <simpleSoccer :event="event" :isRB="true" :widthColumn="widthColumn" :isUnfold="isUnfold" :firstEventEveid="firstEventEveid" :livetvEveid="livetvEveid" v-else></simpleSoccer>
              </template>
            </template> <!-- END League Events -->
            </template> <!-- END League Events -->
          </template> <!-- END sortedRBEventList -->
        </template>
      </template>

      <!-- Normal Fav/Normal Match -->
      <!-- Today Not Started Match -->
      <template v-if="(sortedEventList && sortedEventList.length > 0)">
        <todayHeader :marketType="market.tdyMarket.key" @updateMethod="showMarketMatches"></todayHeader>
        <template v-if="showhideAll">
          <template v-for="(eventObj, eventObjKey) in sortedEventList">
            <!-- League Capt -->
            <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important;" :style="getTop()">
              <div class="list-card-inner" :key="eventObjKey">
                <div class="c-match-league match-tpl0-bg"
                  :class="checkClass(showLgeEve, eventObjKey)" @click="showLeg(eventObjKey, false)">
                  <div class="tr-match-head">
                    <div class="leagues-wrap" :style="{ width: (simpleSport==null)? widthColumn[2] + 'px':'700px' }">
                      <i size="14px" class="icon-arrow q-icon c-icon"></i>
                      <div class="league-icon-wrap">
                        <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                      </div>
                      <div class="ellipsis-wrap">
                        <div class="absolute-full" :title="eventObj[0].lgecapt">
                          <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                          <span class="league-match-count">{{ eventObj.length }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="play-name vrow col">
                      <template v-if="simpleSport==null">
                        <div class="col ellipsis bet-col0">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'] }}
                        </div>
                        <div class="col ellipsis bet-col1">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'] }}
                        </div>
                        <div class="col ellipsis bet-col2">{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'] }}
                        </div>
                        <template v-if="selectedLang == 1">
                          <div class="col ellipsis bet-col3">
                            <div class="double-row">
                              <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2'] }}</div>
                              <div class="highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                              </div>
                            </div>
                          </div>
                          <div class="col ellipsis bet-col4">
                            <div class="double-row">
                              <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP'] }}</div>
                              <div class="highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                              </div>
                            </div>
                          </div>
                          <div class="col ellipsis bet-col5">
                            <div class="double-row">
                              <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U'] }}</div>
                              <div class="highlight-t">
                                {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
                              </div>
                            </div>
                          </div>
                          <template v-if="isUnfold">
                            <div class="col ellipsis bet-col6" v-if="widthColumn[3]==0">
                              <div class="double-row">
                                <div class="">Half With </div>
                                <div class=""> Most Goals</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col7">
                              <div class="double-row">
                                <div class="">{{ sportAllBetLang['ALL_BET.LBL_HOME'] }}</div>
                                <div class="">{{ sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL'] }}</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col8">
                              <div class="double-row">
                                <div class="">{{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}</div>
                                <div class="">{{ sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL'] }}</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col9"> 
                              <div class="double-row">
                                <div class="">Both Teams</div>
                                <div class=""> To Scores</div>
                              </div>
                            </div> 
                            <div class="col ellipsis bet-col10"  v-if="widthColumn[3]<2">
                              <div class="double-row">
                                <div class="">To Win</div>
                                <div class=""> From Behind</div>
                              </div>
                            </div>
                            <div class="col ellipsis bet-col11"> {{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }} </div> 
                            <div class="col ellipsis bet-col12"> {{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }} </div>
                          </template>
                        </template>
                        <template v-else>
                          <div class="col ellipsis bet-col3 highlight-t">
                            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'] }}
                          </div>
                          <div class="col ellipsis bet-col3 highlight-t">
                            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'] }}
                          </div>
                          <div class="col ellipsis bet-col3 highlight-t">
                            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'] }}
                          </div>
                          <template v-if="isUnfold">
                            <div class="col ellipsis bet-col6" v-if="widthColumn[3]==0">{{ sportAllBetLang['ALL_BET.SUBHEADER_HMG'] }}</div>
                            <div class="col ellipsis bet-col7"> {{ sportAllBetLang['ALL_BET.HTG'] }} </div>
                            <div class="col ellipsis bet-col8"> {{ sportAllBetLang['ALL_BET.ATG'] }} </div>
                            <div class="col ellipsis bet-col9">  {{ sportAllBetLang['ALL_BET.SUBHEADER_BTTS'] }}</div> 
                            <div class="col ellipsis bet-col10"  v-if="widthColumn[3]<2">  {{ sportAllBetLang['ALL_BET.SUBHEADER_TWFB'] }}  </div>
                            <div class="col ellipsis bet-col11"> {{ sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'] }} </div> 
                            <div class="col ellipsis bet-col12"> {{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }} </div>
                          </template>
                        </template>
                      </template>
                    </div>
                    <div class="yb-flex-center" style="width: 39px !important;">
                      <div class="icon-wrap m-star-wrap-league"
                        :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }" @click="favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)">
                        <i class=" icon-star q-icon c-icon"
                          :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- League Events -->
            <template v-if="showLgeEve[eventObjKey]">
            <template v-if="!showLgeEve[eventObjKey].hide">
              <template v-for="(event, eventKey) in eventObj">
                <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" style="" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw')" v-if="simpleSport==null">
                  <div class="list-card-inner">
                    <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" style="" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec')">
                      <div class="c-match-item match-tpl0-bg more-handicap csid-1">
                        <div class="process-col yb-flex-center">
                          <sportTime :event="event"></sportTime>
                        </div>

                        <div class="match-handicap-item-wrap">
                          <!-- sub match -->
                          <template v-for="(subMatch, subMatchKey) in (event.sub + 1)" v-if="showSubMatch(subMatch, event, subMatchKey)">
                            <div class="match-handicap-item">
                              <sportTeam :event="event" :issc="true" classes="none" :subMatchKey="subMatchKey" :plyType="ftPlyType" :isRB="false" :widthL="widthColumn[0]">
                              </sportTeam>
                              <div class="c-match-handicap" :id="'cmatch'+event.eveid">
                                <div class="vrow no-wrap">
                                  <!-- FT 1X2 -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+onex2BetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[ftPlyType] && event.od[ftPlyType][onex2BetType] && event.od[ftPlyType][onex2BetType]['oddsh']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">1</template>
                                                <template v-else>{{ sportAllBetLang['ALL_BET.LBL_HOMEWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome"
                                          :plyType="ftPlyType" :betType="onex2BetType" />
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[ftPlyType] && event.od[ftPlyType][onex2BetType] && event.od[ftPlyType][onex2BetType]['oddsa']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">2</template>
                                                <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway"
                                          :plyType="ftPlyType" :betType="onex2BetType" />
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[ftPlyType] && event.od[ftPlyType][onex2BetType] && event.od[ftPlyType][onex2BetType]['oddsd']"> 
                                                  <template v-if="selectedLang=='4' || selectedLang=='11'">X</template>
                                                  <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw"
                                            :plyType="ftPlyType" :betType="onex2BetType" />
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                  <!-- FT HDP -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+hdpBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'a'" :plyType="ftPlyType"
                                              :betType="hdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="hdpBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'b'" :plyType="ftPlyType"
                                              :betType="hdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="hdpBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>
                                  <!-- FT OU -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+ouBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template v-if="event.od[ftPlyType] && event.od[ftPlyType][ouBetType] && event.od[ftPlyType][ouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="ftPlyType" :betType="ouBetType"
                                              :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="ouBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template v-if="event.od[ftPlyType] && event.od[ftPlyType][ouBetType] && event.od[ftPlyType][ouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="ftPlyType" :betType="ouBetType"
                                              :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="ouBetType"
                                          :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>
                                  <!-- 1H 1X2 -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+onex2BetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][onex2BetType] && event.od[firstHtPlyType][onex2BetType]['oddsh']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">1</template>
                                                <template v-else>{{ sportAllBetLang['ALL_BET.LBL_HOMEWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome"
                                          :plyType="firstHtPlyType" :betType="onex2BetType" />
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                              <template
                                                v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][onex2BetType] && event.od[firstHtPlyType][onex2BetType]['oddsa']">
                                                <template v-if="selectedLang=='4' || selectedLang=='11'">2</template>
                                                <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_AWAYWIN'] }}</template>
                                              </template>
                                            </template>
                                          </div>
                                        </div>
                                        <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="firstHtPlyType" :betType="onex2BetType" />
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][onex2BetType] && event.od[firstHtPlyType][onex2BetType]['oddsd']">
                                                  <template v-if="selectedLang=='4' || selectedLang=='11'">X</template>
                                                  <template v-else>{{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}</template>
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="firstHtPlyType" :betType="onex2BetType" />
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                  <!-- 1H HDP -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+hdpBetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'a'" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                          <div class="handicap-value-text">
                                            <handicap :event="event" :favTeam="'b'" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="hdpBetType" :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>
                                  <!-- 1H OU -->
                                  <div class="handicap-col" :id="'handicapCol'+event.eveid+ouBetType+firstHtPlyType+subMatchKeyCap[subMatchKey]">
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template
                                              v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ouBetType] && event.od[firstHtPlyType][ouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamA" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      <div
                                        class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                        <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                          <span class="handicap-more" style="width: min-content;">
                                            <template
                                              v-if="event.od[firstHtPlyType] && event.od[firstHtPlyType][ouBetType] && event.od[firstHtPlyType][ouBetType][getSMKey(subMatchKey)]">
                                              {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                            </template>
                                            &nbsp;
                                          </span>
                                          <div class="handicap-value-text">
                                            <over-under :event="event" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey" />
                                          </div>
                                        </div>
                                        <odd :event="event" :team="teamB" :plyType="firstHtPlyType" :betType="ouBetType" :match="subMatchKey"></odd>
                                      </div>
                                    </div>
                                    <template v-if="subMatchKey == 0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                      </div>
                                    </template>
                                  </div>

                                  <!-- Unfold SC All -->
                                  <template v-if="isUnfold">
                                    <!-- HMG1X2 -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+hmg1x2BetType+ftPlyType+subMatchKeyCap[subMatchKey]" v-if="widthColumn[3]==0">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[ftPlyType] && event.od[ftPlyType][hmg1x2BetType] && event.od[ftPlyType][hmg1x2BetType]['oddsh']">
                                                  {{ lang.sportAllBet['ALL_BET.LBL_1HT'] }}
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome"
                                            :plyType="ftPlyType" :betType="hmg1x2BetType" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0">
                                                <template
                                                  v-if="event.od[ftPlyType] && event.od[ftPlyType][hmg1x2BetType] && event.od[ftPlyType][hmg1x2BetType]['oddsa']">
                                                  {{ lang.sportAllBet['ALL_BET.LBL_2HT'] }}
                                                </template>
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway"
                                            :plyType="ftPlyType" :betType="hmg1x2BetType" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                          <div
                                            class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                            <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                              <div class="handicap-value-text">
                                                <template v-if="subMatchKey == 0">
                                                  <template
                                                    v-if="event.od[ftPlyType] && event.od[ftPlyType][hmg1x2BetType] && event.od[ftPlyType][hmg1x2BetType]['oddsd']">
                                                    {{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}
                                                  </template>
                                                </template>
                                              </div>
                                            </div>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw"
                                              :plyType="ftPlyType" :betType="hmg1x2BetType" />
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                    <!-- HTG -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+htgBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][htgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey == 0" :event="event" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][htgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="htgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- ATG -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+atgBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][atgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="width: min-content;">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][atgBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under v-if="subMatchKey==0" :event="event" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="atgBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- BTTS -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+bttsBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey==0  && event.od[ftPlyType] && event.od[ftPlyType][bttsBetType] && event.od[ftPlyType][bttsBetType]['oddsh']">
                                                {{ sportAllBetLang['ALL_BET.LBL_YES'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="bttsBetType" ref="team1" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][bttsBetType] && event.od[ftPlyType][bttsBetType]['oddsa']">
                                                {{ sportAllBetLang['ALL_BET.LBL_NO'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="bttsBetType" ref="team2" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- To Win from behind -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+twfbBetType+ftPlyType+subMatchKeyCap[subMatchKey]"  v-if="widthColumn[3]<2">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey==0  && event.od[ftPlyType] && event.od[ftPlyType][twfbBetType] && event.od[ftPlyType][twfbBetType]['oddsh']">
                                                {{ sportAllBetLang['ALL_BET.LBL_HOME'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="twfbBetType" ref="team1" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0 && event.od[ftPlyType] && event.od[ftPlyType][twfbBetType] && event.od[ftPlyType][twfbBetType]['oddsa']">
                                                {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="twfbBetType" ref="team2" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- O/E -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+oeBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0 && event.od[ftPlyType] && event.od[ftPlyType][oeBetType]">
                                                {{ sportAllBetLang['ALL_BET.LBL_ODD'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamA" :plyType="ftPlyType" :betType="oeBetType" :match="subMatchKey" ref="teamOdd" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][oeBetType]">
                                                {{ sportAllBetLang['ALL_BET.LBL_EVEN'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd v-if="subMatchKey==0" :event="event" :team="teamB" :plyType="ftPlyType" :betType="oeBetType" :match="subMatchKey" ref="teamEven" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                    <!-- Clean sheet -->
                                    <div class="handicap-col" :id="'handicapCol'+event.eveid+cshBetType+ftPlyType+subMatchKeyCap[subMatchKey]">
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey==0 && event.od[ftPlyType] && event.od[ftPlyType][cshBetType] && event.od[ftPlyType][cshBetType]['oddsh']">
                                                {{ sportAllBetLang['ALL_BET.LBL_HOME'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="cshBetType" ref="team1" />
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <template v-if="subMatchKey == 0  && event.od[ftPlyType] && event.od[ftPlyType][cshBetType] && event.od[ftPlyType][cshBetType]['oddsa']">
                                                {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }}
                                              </template>
                                            </div>
                                          </div>
                                          <odd1x2 v-if="subMatchKey==0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="cshBetType" ref="team2" />
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </div>
                                  </template>
                                </div>
                              </div>
                              <div class="media-col" v-if="subMatchKey==0">
                                <div class="media-col-wrap">
                                  <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                    <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                                  </div>
                                  <div class="yb-flex-center"></div>
                                  <!--div class="icon-wrap relative-position">
                                    <div class="v-icon animation-icon"></div>
                                  </div-->
                                </div>
                              </div>
                            </div>
                          </template>
                          
                          <moreBetComponent v-if="chkMoreBetExist(event)" :event="event"  :widthColumn="widthColumn"  :isUnfold="isUnfold"></moreBetComponent>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <simpleSoccer :event="event" :isRB="false" :widthColumn="widthColumn" :isUnfold="isUnfold" :firstEventEveid="firstEventEveid" :livetvEveid="livetvEveid" v-else></simpleSoccer>
              </template>
            </template> <!-- END League Events -->
            </template> 
          </template> <!-- END sortedEventList -->
        </template>
      </template>
    </template>

    <div class="" v-if="(sortedEventList && Object.keys(sortedEventList).length > 0)">
      <div style="height: 15px;"></div>
      <div class="pager-wrap vrow justify-end">
        <div class="go-top-btn yb-flex-center" @click="backtoTop">
          <i aria-hidden="true" role="presentation" class="q-icon icon-go_top c-icon" style="font-size: 14px;"></i>
          <div class="vmsg">{{ lang.sportAllBet['ALL_BET.BACK_TOP'] }}</div>
        </div>
      </div>
    </div>
    <div class="absolute-full resize-observer-wrap">
      <div class="absolute-full expand"></div>
      <div class="absolute-full shrink"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'

// import DateFilter from '@/vue/filters/date'
// import moment from 'moment'

// import OddComponents from '../../components/odd'
// import Odd1x2Components from '../../components/odd1x2'
// import HandicapComponents from '../../components/handicap'
// import OverUnderComponents from '../../components/over-under'
import sportTime from './sportTimeColumn'
import sportTeam from './sportTeamColumn'
import soccerAllCommon from './soccerAllCommon'
import moreBetComponent from './allBet/more-bet'
import todayHeader from './todayHeader'
import simpleSoccer from './simpleSoccer'

import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    moreBetComponent,
    soccerAllCommon,
    sportTime,
    sportTeam,
    todayHeader,
    simpleSoccer,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      'sortedEventList',
      // 'sortedRBEventList',
      'sortedFavRbEventList',
      'market',
      'selectedShow',
      'selectedMarket',
      'selectedBettype',
      'selectedAllBetNew',
      'selectedMatchAllBet',
      'moreBetLoading',
      'tvIconFlag',
      'favouriteLgeEvents',
      'showFavEvents',
      'show_Unfold',
      'unfold_AllSc',
      'frameWidthHeight',
      'livetv',
      'firstEvent',
      'account',
      'showRBLgeEve',
      'showLgeEve',
      'isParlayTab',
      'isGameBannerSelected',
      'simpleSport',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid:{ 
      get() {
        let ft=this.$store.getters.firstEvent
        return Object.keys(ft).length>0 ? ft.eveid:0
      }
    },
    widthColumn: {
      get() {
        var fm = this.$store.getters.frameWidthHeight
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount =fm.leagueTeam.columnCountBet;
        var columnCountBetShow =fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId
        var tmp = this.$store.getters.selectedBettype.tmpltId
        var hideCol=0;
        
        if(!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]){
          if(pageCenter<=1370){
            columnCountBetShow-=1;
            hideCol+=1;
          }
          if(pageCenter<1280){
            columnCountBetShow-=1;
            hideCol+=1;
          }
          columnCount=columnCountBetShow;
        }
        var AvailableLT = pageCenter-timeColumn-favColumn-(betBoxWidthMin*columnCount)-leagueBoxWidthMin;   
        if(AvailableLT>0){
          let TeamCal = AvailableLT * 0.7;
          team=betBoxWidthMin+(TeamCal/columnCount);
          team= Math.floor(team);
          if(team<betBoxWidthMin){
            team=betBoxWidthMin
          }else if(team>betBoxWidthMax){
            team=betBoxWidthMax;
          }
          let caladd = team-betBoxWidthMin
          if(caladd>0){
            AvailableLT = AvailableLT -((team-betBoxWidthMin)*columnCount)
            if(AvailableLT>0){
              league = AvailableLT+leagueBoxWidthMin
            }
          }else{
            league = AvailableLT+leagueBoxWidthMin
          }
        }else{
          league = AvailableLT+leagueBoxWidthMin
        }
        league=league-15; // minus scroll width + border use
        var league2=league+timeColumn
        return [league,team, league2,hideCol] // Team column , team column , league title
      },
    },
    sortedRBEventList: function() {
      return this.$store.getters.sortedRBEventList
      // if(!this.showFavEvents){
      //   return this.$store.getters.sortedRBEventList
      // } else {
      //   return this.$store.getters.sortedFavRbEventList
      // }
    },
  },
  data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      // moreBetTab: [allBetMixin.data().rcsBetType], 
      moreBetEveId: null,
      showhideAll: true,
      showRBhideAll: true,
      reloadingPer: '0 %',
      showLimit: 6,
      isUnfold: false,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    }
  },
  watch : {
    unfold_AllSc: {
      handler: function (val, oldVal) {
        this.checkUnfold()
      },
      deep: true
    }
  },
  beforeMount() {
    this.checkUnfold()
  },
  mounted() {
    // this.showhideAll = true;
    EventBus.$on('moreBetLoading', ((params) => {
      this.reloadingPer = '75 %';
    }).bind(this))
    
  },
  methods: {
    checkClass(LgeEve, eventObjKey){
      var match =''
      var leagues=''
      if(Object.keys(LgeEve).length > 0){
        if(!_.isUndefined(LgeEve[eventObjKey].hide)){
          match =  !LgeEve[eventObjKey].hide?'match-tpl0':'';
          leagues =  LgeEve[eventObjKey].hide?'leagues-pack':''; 
        }
      }
      
      return match +' '+ leagues
    },
    getSMKey(smKey){
      var smKeyId = ''
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a'
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b'
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c'
      } else {
        smKeyId = 'd'
      }
      return smKeyId
    },
    checkUnfold(){
      var sprt = this.selectedBettype.sprtId
      var tmp = this.selectedBettype.tmpltId
      if(!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])){
        this.isUnfold = this.unfold_AllSc[sprt][tmp]
      }
    },
    getTop(){
      var topVal = (this.selectedMarket == this.$store.getters.market.tdyMarket.key  && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab)) ? '73.5' : '89.5'
      if(this.isGameBannerSelected && this.selectedMarket == this.$store.getters.market.earlyMarket.key){
        topVal = '37.5'
      }

      return 'top:'+topVal+'px'
    },
    showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll
      } else {
        this.showhideAll = !this.showhideAll
      }
    },
    showhideMain(isRB) {
      var key = ''
      if (!isRB) {
        this.showhideAll = (this.showhideAll) ? false : true;
        for (key in this.sortedEventList) {
          this.$set(this.sortedEventList[key], 'hide', !this.showhideAll)
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = (this.showRBhideAll) ? false : true;
        // if (this.showFavEvents) {
        //   for (key in this.sortedFavRbEventList) {
        //     this.$set(this.sortedRBEventList[key], 'hide', !this.showRBhideAll)
        //     // this.$set(this.sortedFavRbEventList[key], 'hide', !this.showRBhideAll)
        //   }
        // }
      }
    },
    showLeg(key, isRB) {
      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide)
        // this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)
      } else if (isRB) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide)
        // this.$set(this.sortedRBEventList[key], 'hide', !this.sortedRBEventList[key].hide)
      }

      //if (this.showFavEvents && isRB) {
      //  this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide)
      //}
    },
    countAllBet(event, selectedShow) {
      var countCv = event.all
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (selectedShow == 3 && plyTypes == 2) {
          } else if (selectedShow == 4 && plyTypes == 1) {
          } else {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (bidx == 4 || bidx == 11) {
                if (selectedShow == 2) {
                  --countCv;
                }
              }
            });
          }
        });
      }
      return countCv;
    },
    enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8,
      })
    },
    enterAllBet(event,startTv, isRB=false) {
      this.$store.commit('SHOW_UNFOLD', true)
      this.$store.commit('SHOW_FOLD', false)
      this.$store.commit('UNFOLD_ALLSC', false)
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv=1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,
        // isRB: (event.rbstatus==1) ? true : false,
        token: token.arr_8,
        loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
      if(startTv == 1){
        this.$store.commit('RIGHT_BOARD_CHG', event)
      }
    },
    backtoTop() {
      // $(".list-scrollbar").animate({ scrollTop: 0 },100);
      $(".sport-table-scroll").animate({ scrollTop: 0 },100);
    },
    // backtoTop() {
    //   $('html, body').animate({
    //     scrollTop: 0
    //   }, 400);
    // },
    // chkMoreBetExist(event) {
    //   let vue = this
    //   let exist = false

    //   _.forEach(event.od, function (ptydata, key) {
    //     _.forEach(ptydata, function (val, k) {
    //       if ($.inArray(k, vue.moreBetTab) > -1) {
    //         exist = true
    //       }
    //     })
    //   })

    //   return exist
    // },
  },
  updated() { 
    $('.ellipsis').bind('mouseenter', function(){
        var $this = $(this);
        if(this.offsetWidth < this.scrollWidth && !$this.attr('title')){
            $this.attr('title', $this.text());
        }
    });
  },
  beforeDestroy() {
    this.$store.commit('SHOW_RBLGEEVE', [])
    this.$store.commit('SHOW_LGEEVE', {})
  },
  destroyed() {
    EventBus.$off('moreBetLoading')
    
  },
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/soccerCommon.vue